import { memo } from 'react';

import InputWithOverlay from '@ui/input-with-overlay/input-with-overlay';

type TEditLocationProps = {
  location: string | undefined;
  onChange: (value: string) => void;
};

const EditLocation = memo(({ location, onChange }: TEditLocationProps) => {
  return (
    <label htmlFor="location" className="flex-1 flex-column gap-4 width-100-percent">
      <InputWithOverlay
        label="Location"
        inputProps={{
          id: 'location',
          value: location || '',
          onChange: (e) => onChange(e.target.value),
          placeholder: 'Add location',
        }}
      />
    </label>
  );
});

EditLocation.displayName = 'EditLocation';

export default EditLocation;
